/**
 * Module de monitoring centralisé.
 * Envoie les logs vers le Dashboard ERP.
 * Ne JAMAIS faire throw d'erreur ici pour ne pas bloquer l'app client.
 */

/**
 * Collecte automatiquement le contexte navigateur/environnement.
 */
function getBrowserContext() {
  if (typeof window === "undefined") {
    return { environment: "server-side" };
  }

  const nav = window.navigator || {};
  const perf = window.performance || {};
  const conn =
    nav.connection || nav.mozConnection || nav.webkitConnection || {};

  return {
    // Navigation
    url: window.location.href,
    path: window.location.pathname,
    referrer: document.referrer || null,

    // Navigateur
    userAgent: nav.userAgent,
    language: nav.language,
    languages: nav.languages ? [...nav.languages] : [],
    cookiesEnabled: nav.cookieEnabled,
    online: nav.onLine,

    // Écran
    screenWidth: window.screen?.width,
    screenHeight: window.screen?.height,
    viewportWidth: window.innerWidth,
    viewportHeight: window.innerHeight,
    devicePixelRatio: window.devicePixelRatio,

    // Réseau (si disponible)
    connectionType: conn.effectiveType || null,
    connectionDownlink: conn.downlink || null,

    // Performance
    memoryUsage: perf.memory
      ? {
          usedJSHeapSize: perf.memory.usedJSHeapSize,
          totalJSHeapSize: perf.memory.totalJSHeapSize,
        }
      : null,

    // Timestamp
    timestamp: new Date().toISOString(),
  };
}

/**
 * Envoie un log vers le Dashboard ERP centralisé.
 *
 * @param {string} level - INFO | WARN | ERROR | CRITICAL
 * @param {string} category - AUTH | DB | UI | PAYMENT | SYSTEM | OTHER
 * @param {string} message - Description lisible de l'événement
 * @param {object} context - Données supplémentaires spécifiques à l'événement
 */
export async function logEvent(level, category, message, context = {}) {
  try {
    const API_KEY = process.env.REACT_APP_MONITORING_API_KEY;

    const browserContext = getBrowserContext();

    await fetch("https://logevent-ta6wobnraq-ew.a.run.app", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": API_KEY,
      },
      body: JSON.stringify({
        level,
        category,
        message,
        context: {
          ...context,
          browser: browserContext,
        },
        url: browserContext.url || "server-side",
      }),
    });
  } catch (e) {
    // Failsafe silencieux : si le monitoring tombe, le site client doit continuer de fonctionner.
    console.error("Monitoring API unavailable");
  }
}

/**
 * Sérialise un objet Error en objet plain pour le logging.
 */
export function serializeError(error) {
  if (!error) return {};
  return {
    message: error.message || String(error),
    name: error.name || "Error",
    stack: error.stack || null,
    code: error.code || null,
  };
}
